import React, { JSX } from 'react';
import getFileExtension from 'util/FileExtension/GetFileExtension';
import { FileTypeIconSize, getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { Icon as FluentuiIcon } from '@fluentui/react/lib/Icon';

interface Props {
  className?: string;
  size?: FileTypeIconSize;
  name: string;
}

export default function FileIcon({ name, size = 20, className }: Props): JSX.Element {
  const extension = getFileExtension(name);
  return <FluentuiIcon {...getFileTypeIconProps({ extension: extension, size })} className={className} />;
}
